import React from "react";

import { NavLink, type To } from "react-router-dom";

import style from "./BreadCrumbs.module.css";

interface BreadCrumbsProps {
  children: React.ReactNode;
}

export const BreadCrumbs: React.FC<BreadCrumbsProps> = ({ children }) => {
  const items = React.Children.toArray(children);

  return (
    <div className={style.container}>
      {items.map((item, i) => (
        <React.Fragment key={i}>
          {item}
          {i < items.length - 1 && <div className={style.separator}> / </div>}
        </React.Fragment>
      ))}
    </div>
  );
};

interface CrumProps {
  children: React.ReactNode;
  icon?: React.ReactNode;
  to: To;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
}

export const Crumb: React.FC<CrumProps> = ({ children, to, icon, onClick }) => {
  return (
    <NavLink to={to} className={style.crumb} onClick={onClick}>
      {icon && <div className={style.crumbIcon}>{icon}</div>}
      <span className={style.crumbText} title={typeof children === "string" ? children : undefined}>
        {children}
      </span>
    </NavLink>
  );
};
